import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useCookieConsent } from 'src/cookies/CookieConsentContext';

const usePageTracking = () => {
  const location = useLocation();
  const { hasConsentFor } = useCookieConsent();
  const GA_MEASUREMENT_ID = import.meta.env
    .VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID;
  const hasInitializedAnalytics = useRef(false);

  useEffect(() => {
    if (GA_MEASUREMENT_ID && hasConsentFor('analytics')) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }
  }, [GA_MEASUREMENT_ID, hasConsentFor, location]);

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) {
      return;
    }

    const gaDisableKey = `ga-disable-${GA_MEASUREMENT_ID}`;
    const analyticsEnabled = hasConsentFor('analytics');

    (window as unknown as Record<string, boolean>)[gaDisableKey] =
      !analyticsEnabled;

    if (!analyticsEnabled) {
      return;
    }

    if (!hasInitializedAnalytics.current) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
      hasInitializedAnalytics.current = true;
    }
  }, [GA_MEASUREMENT_ID, hasConsentFor]);
};

export default usePageTracking;
